import { render, staticRenderFns } from "./PortalCampaignBanner.vue?vue&type=template&id=198baf2a"
import script from "./PortalCampaignBanner.vue?vue&type=script&lang=js"
export * from "./PortalCampaignBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports